import React from 'react';

function Dashboard({ reports, onDeleteReport }) {
  return (
    <div style={{ padding: '30px', fontFamily: 'Arial' }}>
      <h2 style={{ textAlign: 'center', marginBottom: '25px', color: '#2c3e50' }}>Compliance Reports</h2>
      <div style={{ overflowX: 'auto' }}>
        <table style={tableStyle}>
          <thead>
            <tr style={headerRowStyle}>
              <th style={headerCellStyle}>State</th>
              <th style={headerCellStyle}>Document Type</th>
              <th style={headerCellStyle}>Compliance Score</th>
              <th style={headerCellStyle}>Found Keywords</th>
              <th style={headerCellStyle}>Missing Keywords</th>
              <th style={headerCellStyle}>Action</th>
            </tr>
          </thead>
          <tbody>
            {reports.map((report, index) => (
              <tr key={index} style={index % 2 === 0 ? evenRowStyle : oddRowStyle}>
                <td style={cellStyle}>{report.state}</td>
                <td style={cellStyle}>{report.documentType}</td>
                <td style={cellStyle}>{report.complianceScore}%</td>
                <td style={cellStyle}>{report.foundKeywords.join(', ')}</td>
                <td style={cellStyle}>{report.missingKeywords.join(', ')}</td>
                <td style={cellStyle}>
                  <button
                    style={deleteButtonStyle}
                    onClick={() => onDeleteReport(index)}
                  >
                    ❌
                  </button>
                </td>
              </tr>
            ))}
            {reports.length === 0 && (
              <tr>
                <td colSpan="6" style={{ ...cellStyle, textAlign: 'center', padding: '20px', color: '#888' }}>
                  No reports submitted yet.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

// 🎨 Inline Styles
const tableStyle = {
  width: '100%',
  borderCollapse: 'collapse',
  borderRadius: '10px',
  overflow: 'hidden',
  boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
  backgroundColor: '#fff',
};

const headerRowStyle = {
  backgroundColor: '#ecf0f1',
};

const headerCellStyle = {
  padding: '12px',
  fontWeight: 'bold',
  textAlign: 'left',
  fontSize: '14px',
  borderBottom: '2px solid #ccc',
};

const cellStyle = {
  padding: '12px',
  fontSize: '13px',
  textAlign: 'left',
  borderBottom: '1px solid #e0e0e0',
  verticalAlign: 'top',
};

const evenRowStyle = {
  backgroundColor: '#ffffff',
};

const oddRowStyle = {
  backgroundColor: '#f8f9fa',
};

const deleteButtonStyle = {
  backgroundColor: '#e74c3c',
  color: '#fff',
  border: 'none',
  borderRadius: '4px',
  padding: '6px 10px',
  cursor: 'pointer',
};

export default Dashboard;